import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Section } from 'foundations-components/transitional/components/Section';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { Fragment } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ServiceGridItem({
  illustrationName,
  textKey
}) {
  const {
    marginBottom
  } = useResponsiveProps({
    marginBottom: {
      xs: '1000',
      sm: undefined
    }
  });
  return /*#__PURE__*/_jsx(GridItem, {
    size: {
      xs: 12,
      sm: 4
    },
    marginBlockEnd: marginBottom,
    children: /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      align: "center",
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: illustrationName,
        height: 120
      }), /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: textKey
        })
      })]
    })
  });
}
export default function ServicesGrid() {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsxs(Grid, {
        children: [/*#__PURE__*/_jsx(ServiceGridItem, {
          illustrationName: "content-strategy",
          textKey: "marketplaceUnified.providerServices.marketingServices"
        }), /*#__PURE__*/_jsx(ServiceGridItem, {
          illustrationName: "sales-professional",
          textKey: "marketplaceUnified.providerServices.salesEnablement"
        }), /*#__PURE__*/_jsx(ServiceGridItem, {
          illustrationName: "deals",
          textKey: "marketplaceUnified.providerServices.crmImplementation"
        })]
      })
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsxs(Grid, {
        children: [/*#__PURE__*/_jsx(ServiceGridItem, {
          illustrationName: "marketing-templates",
          textKey: "marketplaceUnified.providerServices.websiteDesign"
        }), /*#__PURE__*/_jsx(ServiceGridItem, {
          illustrationName: "api",
          textKey: "marketplaceUnified.providerServices.appDevelopment"
        }), /*#__PURE__*/_jsx(ServiceGridItem, {
          illustrationName: "nps-question",
          textKey: "marketplaceUnified.providerServices.customerSuccessServices"
        })]
      })
    })]
  });
}